<template>
	<v-responsive 
		:aspect-ratio="aspectRatio"
		v-bind="$attrs"
	>
		<iframe
			width="100%"
			height="100%"
			:src="src"
			frameborder="0"
			allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
			allowfullscreen
		/>
	</v-responsive>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
	data:() => ({
		aspectRatio: null,
		src: null
	}),
	computed: {
		...mapGetters(['config'])
	},
	mounted() {
		this.aspectRatio = this.$attrs['aspect-ratio'] || 16/9
		this.src = this.$slots.default[0].text.trim()
	}
}

</script>
